module.exports = function formatDate(date, fmt) {
  function pad(value) {
    return (value.toString().length < 2) ? '0' + value : value;
  }
  return fmt.replace(/%([a-zA-Z]+)/g, function (_, fmtCode) {
    switch (fmtCode) {
      case 'd':
        return pad(date.getDate());
      case 'M':
        return pad(date.getMonth() + 1);
      case 'Y':
        return date.getFullYear();
      case 'H':
        return pad(date.getHours());
      case 'm':
        return pad(date.getMinutes());
      case 's':
        return pad(date.getSeconds());
      default:
        throw new Error('Unsupported format code: ' + fmtCode);
    }
  });
}

